import { componentFactoryOf } from 'vue-tsx-support';

import { injectStylesMixin } from '../../mixins/inject-styles';

import styles from './jtn-ui-radio-button.styles.scss?module';

interface Events {
  onChange: Event;
}

export default componentFactoryOf<Events>()
  .mixin(injectStylesMixin(styles))
  .create({
    name: 'JtnUiRadioButton',
    props: {
      name: {
        type: String,
        default: ''
      },
      value: {
        type: String,
        default: ''
      },
      checked: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      emitChangeEvent(event: Event) {
        this.$emit('change', event);
      }
    },
    render() {
      return (
        <label class={styles.radioButtonWrap}>
          <input
            class={styles.inputHidden}
            name={this.name}
            type="radio"
            checked={this.checked}
            value={this.value}
            onChange={this.emitChangeEvent}
          />
          <div class={styles.inner}>
            <span class={styles.radioButton}></span>
            <span class={styles.radioText}>{this.$slots.default}</span>
          </div>
        </label>
      );
    }
  });
